export default __webpack_public_path__ + "static/media/bg-set-game-level.fa0f48c9.png";